import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jobTitle'
})
export class JobtitlePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value?.split(' ').map(([firstChar, ...rest]) => firstChar?.toUpperCase() + rest?.join('')?.toLowerCase())?.join(' ');
  }

}
